import {FilterIcon} from '@heroicons/react/outline';

import useCloseOnOutsideClick from '@/hooks/useCloseOnOutsideClick';

export interface FilterProps {
  handleShowFilter: () => void;
  closeFilter: () => void;
  label: string;
  bodyClassName?: string; // Changed to string for consistency with Tailwind
  positionLeft?: number; // Optional, defaults to auto-adjustment
  disabled?: boolean;
  title?: string;
  [rest: string]: unknown;
}

export const Filter: React.FC<React.PropsWithChildren<FilterProps>> = ({
  handleShowFilter,
  closeFilter,
  label,
  bodyClassName,
  children,
  positionLeft = 0, // Default to 0, will be adjusted dynamically
  disabled = false,
  title = '',
  ...rest
}) => {
  const containerRef = useCloseOnOutsideClick<HTMLDivElement>(closeFilter);

  return (
    <div className="relative w-full" ref={containerRef}>
      {/* Trigger Button */}
      <div
        onClick={!disabled ? handleShowFilter : undefined}
        title={title}
        {...rest}
        className={`inline-flex items-center border border-gray-300 dark:border-dark-borderHeavy rounded-md px-3 h-10 bg-white dark:bg-transparent md:px-4 md:h-11 ${
          disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        }`}
      >
        <FilterIcon className="h-5 w-5 text-gray-400 mr-2" />
        <p className="text-sm font-semibold text-gray-700 dark:text-gray-100">
          {label}
        </p>
      </div>

      {/* Dropdown Popup */}
      {children && (
        <div
          className="absolute w-full mt-2 z-40 md:w-auto md:max-w-md lg:max-w-lg"
          style={{
            left: positionLeft ? `${positionLeft}px` : 'auto', //use prop if provided, otherwise auto
            right: positionLeft ? 'auto' : 0, //adjust right if no left is specified
            minWidth: 'calc(100vw - 30px)', //minimum width for smaller screens
            maxWidth: '600px', //max width for larger screens
          }}
        >
          <div
            className={`bg-white dark:bg-dark-inputBg border border-gray-300 dark:border-dark-borderHeavy rounded-lg shadow-lg p-4 ${bodyClassName}`}
          >
            <div className="flex flex-col gap-4 sm:grid sm:grid-cols-2 lg:grid-cols-3 justify-self-stretch w-full col-span-full">
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Use this to center filter body when needed
// -translate-x-1/2  left-1/2 left-[150px] w-[300px] sm:w-[600px]

//left 100 works for transactions
